import { render } from "./LmvCarousel.vue?vue&type=template&id=363e14f8"
import script from "./LmvCarousel.vue?vue&type=script&lang=js"
export * from "./LmvCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__